import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const ComingSoon = () => (
  <div style={{minHeight: '100vh', background: '#FEFCF6', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: '"Cormorant Garamond", serif'}}>
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '32px', maxWidth: '420px', textAlign: 'center'}}>
      <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
        <span style={{color: '#3A7D44', fontSize: '24px'}}>&#10022;</span>
        <div>
          <div style={{color: '#1A3A20', fontSize: '24px', letterSpacing: '0.15em', fontWeight: 300}}>sattvik</div>
          <div style={{color: '#3A7D44', fontSize: '10px', letterSpacing: '0.35em', textTransform: 'uppercase', fontFamily: '"DM Sans", sans-serif'}}>EARTH</div>
        </div>
      </div>
      <div style={{width: '64px', height: '1px', background: 'rgba(58,125,68,0.3)'}} />
      <h1 style={{fontSize: 'clamp(28px, 5vw, 40px)', color: '#1A3A20', fontWeight: 300, lineHeight: 1.3, margin: 0}}>
        Something new is brewing<span style={{color: '#3A7D44'}}>...</span>
      </h1>
      <p style={{color: '#7C7C7C', fontSize: 'clamp(15px, 3vw, 18px)', fontFamily: '"DM Sans", sans-serif', lineHeight: 1.7, margin: 0}}>
        We are crafting a fresh experience for you.<br />Clean, unpolished, and worth the wait.
      </p>
      <div style={{display: 'flex', alignItems: 'center', gap: '12px', color: 'rgba(58,125,68,0.6)', fontSize: '14px', fontFamily: '"DM Sans", sans-serif'}}>
        <div style={{width: '8px', height: '8px', borderRadius: '50%', background: '#3A7D44', animation: 'pulse 2s infinite'}} />
        Coming soon
      </div>
    </div>
    <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }`}</style>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<ComingSoon />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
